export enum HaulerType {
    INDEPENDENT_HAULER = 'INDEPENDENT_HAULER',
    DONATION_HAULER = 'DONATION_HAULER'
}



// WEBPACK FOOTER //
// ./src/types/enums/HaulerType.ts